<template lang="pug">
  .repeat-delivery-modal
    b-loading(:active.sync="isLoading")
    .modal-card
      .modal-card-head
        p.modal-card-title {{ getFormattedDeliveryDocumentType(documentType) }} erneut senden
        button.delete(@click="$emit('close')") Schließen
      .modal-card-body
        //- Show current request error
        article(class="message is-danger", v-if="requestError != null")
          .message-header: p Fehler
          .message-body {{ requestError }}
        form(@submit.prevent="")
          .content
            .columns
              .column
                b-field(
                  label="Empfänger"
                )
                  b-input(
                    v-model="name"
                    type="text"
                    name="name"
                    data-vv-as="Name"
                    v-validate="'required'"
                    expanded
                    :disabled="deliveries.length === 0"
                  )
              .column
                b-field(
                  label="E-Mail Adresse"
                )
                  b-input(
                    v-model="email"
                    type="text"
                    name="email"
                    data-vv-as="E-Mail"
                    v-validate="'required|email'"
                    expanded
                    :disabled="deliveries.length === 0"
                  )
      .modal-card-foot
        button.submit.button.is-primary(@click="repeatDelivery()" :disabled="errors.any()") Senden
        button.button(type="button", @click="$parent.close()") Abbrechen

  </div>
</template>

<script>

import LicenseAPI from '@/services/api/License'
import DeliveryAPI from '@/services/api/Delivery'
import DeliveryMixin from '@/mixins/delivery'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },
  name: 'RepeatDeliveryModal',
  mixins: [DeliveryMixin],
  props: {
    license: {
      type: String,
      required: true
    },
    documentType: {
      type: String,
      validator: value => ['license', 'starter'].includes(value),
      required: true
    }
  },
  data () {
    return {
      email: null,
      name: null,
      deliveries: [],
      requestError: null,
      isLoading: false
    }
  },
  created () {
    this.fetchData()
  },
  mounted () {
    this.$validator.validateAll()
  },
  methods: {
    fetchData: async function () {
      this.isLoading = true
      try {
        const response = await LicenseAPI.getDeliveriesForLicense(this.license)
        // If there is no delivery for the license
        const allDeliveries = response.data.data.deliveries
        this.deliveries = allDeliveries.filter(d => d.documentType === this.documentType)
        if (allDeliveries.length === 0 || this.deliveries.length === 0) {
          throw new Error('Keine Auslieferungen für diese Lizenz gefunden. An dieser Stelle kann keine erste Auslieferung erstellt werden.')
        }
        this.email = this.deliveries[0].recipient
        this.name = this.deliveries[0].recipientName
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.requestError = error.message ?? 'Fehler beim Abrufen der Daten'
      }
    },
    repeatDelivery: async function () {
      const isFormValid = await this.$validator.validateAll()
      if (!isFormValid) {
        return
      }
      this.requestError = null
      try {
        // safeguard for API Call because buttons and inputs can be enabled. should not be achieved by false or missing values
        if (this.deliveries.length === 0) {
          console.error('No deliveries found, cannot repeat delivery.')
          return
        }
        await DeliveryAPI.create({ licenseID: this.license, email: this.email, name: this.name })
        this.$buefy.toast.open({
          message: 'Erneut gesendet',
          type: 'is-success'
        })
        this.$parent.close()
      } catch (error) {
        this.requestError = error
      }
    }
  }
}
</script>
